import React, { useState, useRef, useEffect } from "react"
import { selectLoading } from "modules/notification"
import { useSelector, useDispatch } from "react-redux"
import { cloneDeep } from "lodash"
import CampaignProductDropdownSearchComponent from "./campaignProductDropdownSearch.component"
import CampaignProductDropdownSearchPanelComponent from "./campaignProductDropdownSearchPanel.component"
import { getCampaignProductDropdown } from "modules/consumer/redux/action/consumer.action"
import consumerApi from "app/api/consumer"
import { setCampaignV2ProductDropdown } from "modules/consumer/redux/slice/consumer.slice"

function CampaignProductDropdownSearchContainer({
    handleChange,
    disabled,
    value,
    styles,
    textStyles,
    placeholder,
    id,
    handleChipDelete,
    isEmpty,
    type
}) {
    const isFetching = useSelector(state => selectLoading(state, getCampaignProductDropdown.typePrefix))
    const campaignProductDropdown = useSelector((state) => state.consumer.campaignProductDropdown)
    const campaignV2ProductDropdown = useSelector((state) => state.consumer.campaignV2ProductDropdown)
    const [open, setOpen] = useState(false)
    const [isOpenList] = useState(false)
    const anchorRef = useRef(null)
    const prevOpen = useRef(open)
    const prevOpenList = useRef(isOpenList)
    const [selectAll, setSelectAll] = useState(false)
    const [search, setSearch] = useState("")
    const lang = useSelector(state => state.constant.languages)
    const dispatch = useDispatch()
    const drawerOpen = useSelector((state) => state.app.drawerOpen)
    const [extraChip, setExtraChip] = useState({
        count: 0,
        offset: 0,
        allOverflow: false
    });

    const adjustField = (ref) => {
        let children = ref.current?.children[0]?.children;
        let p = ref.current?.children[0];
        if (!children) return;

        if (children.length > 0) {
            // Need to exclude placeholder
            if (children[0].role == null) return;

            children = [...children];

            // max width is 90%. Use 0.9 to calc field width
            let panelWidth = ref.current?.scrollWidth * 0.9;
            let childWidth = 0;

            // Check for no overflow child count
            let inRangeCount = children.filter((child, index) => {

                let panelContentWidth = p.getBoundingClientRect().width
                // get exact width + padding with decimal
                childWidth += (parseInt(window.getComputedStyle(child).marginRight) + child.getBoundingClientRect().width);

                // Check if overflow
                if (panelWidth - panelContentWidth < 1) {
                    // need to add 0.5 as the ellipsis padding (0.5 = ellipsis padding)
                    // if the overflow happen before last child, need inlude another 10 for the ellipsis (10 = ellipsis width)
                    return (index !== (children.length - 1)) ? (childWidth + 10.5) < panelContentWidth : childWidth + 0.5 < panelContentWidth;
                }

                return (panelWidth > panelContentWidth);
            }).length;

            if (inRangeCount > 0) {

                let lastRangeChild = children[inRangeCount - 1];

                let outRangeChild = value.slice(inRangeCount);

                // Check for overflow child count
                let extraCount = value.length - inRangeCount;
                setExtraChip({
                    count: extraCount,
                    offset: lastRangeChild.offsetLeft + lastRangeChild.offsetWidth,
                    allOverflow: false,
                    overflowChild: outRangeChild
                });
            } else {
                setExtraChip({
                    count: children.length,
                    offset: 0,
                    allOverflow: true,
                    overflowChild: value
                });
            }
        } else {
            setExtraChip({
                count: 0,
                offset: 0,
                allOverflow: false,
                overflowChild: []
            });
        }
    }

    useEffect(() => {
        if (type === "campaign") {
            consumerApi.getCampaignV2ProductDropdown({ id, search }).then((response) => {
                dispatch(setCampaignV2ProductDropdown(response.data.products));
            });
        } else {
            dispatch(getCampaignProductDropdown({ id, search }))
        }
    }, [dispatch, id, search, type])

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    useEffect(() => {
        if (prevOpenList.current === true && isOpenList === false) {
            anchorRef.current.focus()
        }

        prevOpenList.current = isOpenList
    }, [isOpenList])

    useEffect(() => {
        const productDropdown = type === "campaign" ? campaignV2ProductDropdown : campaignProductDropdown;
        setSelectAll(value.length === productDropdown.length);
    }, [value, campaignProductDropdown, campaignV2ProductDropdown, type]);

    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        setSearch("")
    }
    const handleSelectAll = async () => {
        const productDropdown = type === "campaign" ? campaignV2ProductDropdown : campaignProductDropdown;
        if (!selectAll) {
            let selectedProducts = productDropdown.map(p => {
                return p.uuid;
            });
            handleChange(selectedProducts);
        } else {
            handleChange([]);
        }
    };

    const handleSelectProduct = (product) => {
        let temp = cloneDeep(value)

        if (temp.findIndex(t => t === product.uuid) >= 0) {
            temp = temp.filter(t => t !== product.uuid)
        } else {
            temp.push(product.uuid)
        }
        handleChange(temp)
    }

    const handleSearch = (value) => {
        setSearch(value)
    }

    return (
        <>
            <CampaignProductDropdownSearchComponent
                anchorRef={anchorRef}
                disabled={disabled}
                value={value}
                handleClick={handleOpen}
                styles={styles}
                textStyles={textStyles}
                placeholder={placeholder}
                lang={lang}
                handleChange={handleChange}
                handleChipDelete={handleChipDelete}
                drawerOpen={drawerOpen}
                extraChip={extraChip}
                adjustField={adjustField}
                isEmpty={isEmpty}
                productDropdown={type === "campaign" ? campaignV2ProductDropdown : campaignProductDropdown}

            />
            <CampaignProductDropdownSearchPanelComponent
                selectAll={selectAll}
                value={value}
                anchorRef={anchorRef}
                open={open}
                isOpenList={isOpenList}
                handleClose={handleClose}
                isFetching={isFetching}
                productDropdown={type === "campaign" ? campaignV2ProductDropdown : campaignProductDropdown}
                handleSelectAll={handleSelectAll}
                handleSelectProduct={handleSelectProduct}
                handleSearch={handleSearch}
            />
        </>
    )
}

export default CampaignProductDropdownSearchContainer